// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2SJiB","title":"Header_title__2W3-S","side":"Header_side__26Yvc"};